require('../../globals'); // some angular libs expect angular on the window

require('ng-draggable');
require('angular-filter');
require('angular-ui-router');
require('angular-ui-router/release/stateEvents')
require('ng-file-upload');
require('angular-media-queries');
require('angular-breadcrumb');
require('ng-tags-input');
require('angular-ui-select2/src/select2');
require('ui-select');
require('angular-ui-ace/src/ui-ace');
require('ngreact/ngReact');
require('angular-animate');
require('angular-elastic/elastic');

/**
 * Central source of mappings of npm project names to angular module name,
 * so that angular modules can be `require`d in a fashion somewhat similar to CommonJS modules.
 * Also handles the actual loading of the projects to the angular module tree (by `require`ing them above)
 */


var angularModuleNameOfDependency = {
  'ng-draggable': 'ngDraggable',
  'angular-filter': 'angular.filter',
  'angular-ui-router': 'ui.router',
  'state-events': 'ui.router.state.events',
  'ng-file-upload': 'ngFileUpload',
  'angular-media-queries': 'matchMedia',
  'angular-breadcrumb': 'ncy-angular-breadcrumb',
  'ng-tags-input': 'ngTagsInput',
  'angular-ui-select2': 'ui.select2',
  'ui-select': 'ui.select',
  'angular-ui-ace': 'ui.ace',
  'react': 'react'
}

module.exports = function angularRequire(moduleName) {
  const name = angularModuleNameOfDependency[moduleName]
  if (!name) throw 'no angular module defined for ' +  moduleName;
  else return name
}
